import { render, staticRenderFns } from "./SafetyHealthReply.vue?vue&type=template&id=a8063e84"
import script from "./SafetyHealthReply.vue?vue&type=script&lang=js"
export * from "./SafetyHealthReply.vue?vue&type=script&lang=js"
import style0 from "./SafetyHealthReply.vue?vue&type=style&index=0&id=a8063e84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports